export default [
    {
        path: 'relatorio-faltoso-aprazamento',
        component: () => import(
            /* webpackChunkName: 'imunizacao-relatorio-faltoso-aprazamento' */
            '@/views/imunizacao/relatorio-faltoso-aprazamento/Index'
        ),
        redirect: 'relatorio-faltoso-aprazamento/index',
        children: [
            {
                name: 'imunizacao-relatorio-faltoso-aprazamento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'imunizacao-relatorio-faltoso-aprazamento' */
                    '@/views/imunizacao/relatorio-faltoso-aprazamento/List.vue'
                ),
            },
        ],
    },
]